import { combineReducers } from '@ngrx/store';

import { benefitsReducer as benefits } from '@app/store/reducers/global/benefits.reducer';
import { airFiltersReducer as airFilters } from '@app/store/reducers/global/air-filters.reducer';
import { hotelFiltersReducer as hotelFilters } from '@app/store/reducers/global/hotel-filters.reducer';
import { modalPrimeReducer as modalPrime } from '@app/store/reducers/global/modal-prime.reducer';

export const globalReducer = combineReducers({
  benefits,
  airFilters,
  hotelFilters,
  modalPrime
});
